import React from 'react';

export const AdminDashboard = () => {
  return (
    <div>
      <h1>Welcome to Iconic Travels admin dashboard</h1>
    </div>
  );
};

export default AdminDashboard;
